import localFont from "next/font/local";

export const landingDisplayFont = localFont({
  src: "../../../app/fonts/unbounded-bold-latin.woff2",
  weight: "700",
  variable: "--font-landing-display",
  display: "swap",
  fallback: ["Inter Fallback", "sans-serif"],
});

export const DISPLAY_HEADING_CLASSES =
  "font-[family-name:var(--font-display)] font-bold tracking-[-0.03em]";

export const DESKTOP_DISPLAY_HEADING_CLASSES =
  "font-semibold sm:font-[family-name:var(--font-display)] sm:font-bold sm:tracking-[-0.03em]";
